import PDLTypography from "../../../components/dna/_pdltypography";
import { Pagination } from "../../../components/global";
import ResultItem from "../../../components/pages/results/_resultItem";

interface SavedItemsListProps {
  items: any[];
  searchTerm?: string;
  onRemove?: (item: any) => void;
  currentPage?: number;
  totalPages?: number;
  onPageChange?: (page: number) => void;
}

const SavedItemsList = ({
  items,
  searchTerm = "",
  onRemove,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
}: SavedItemsListProps) => {
  if (items.length === 0) {
    return (
      <PDLTypography size="sm" className="text-muted">
        Nenhum item encontrado
      </PDLTypography>
    );
  }

  return (
    <>
      <div className="results-container">
        {items.map((item, index) => {
          const getItemType = (): string => {
            const rawType = item?.type || item?.tipo;
            const typeValid =
              typeof rawType === "string" ? rawType.toLowerCase() : "";
            if (
              [
                "jurisprudencia",
                "legislacao",
                "doutrinas",
                "modelos",
                "peticoes",
              ].includes(typeValid)
            ) {
              return typeValid;
            }

            if (typeValid === "modelo") return "modelos";

            if (item?.tribunal) return "jurisprudencia";
            if (item?.autores || item?.autor) return "doutrinas";
            if (item?.nome || item?.id || item?.numero || item?.tipo_doc)
              return "legislacao";
            if (item?.titulo || item?.texto) return "modelos";

            return "peticoes";
          };

          return (
            <ResultItem
              key={index}
              item={item as any}
              tipo={getItemType() as any}
              index={index}
              pushDown={true}
              cardProfileStyle={true}
              onRemove={onRemove as any}
            />
          );
        })}
      </div>
      {items.length > 0 && totalPages > 1 && onPageChange && (
        <div className="mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
            showFirstLast={true}
            showPrevNext={true}
            maxVisiblePages={5}
            size="md"
          />
        </div>
      )}
    </>
  );
};

export default SavedItemsList;
